// ----------------------------------------------------------------------------
// Optional Feature: Sticky Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_header--sticky.scss';

// -------------------------------------
// Variables
// -------------------------------------
var lastScrollTop = 0;
var directionStartScrollTop = 0;
var lastScrollDirection = null;
var stickyTicking = false;

// Selectors
var HEADER_SELECTOR = '#shopify-section-header';
var PRODUCT_SECTION = '#shopify-section-product';
var DESKTOP_MEDIA_QUERY = '(min-width: 1024px)';

// Classes
var STICKY_CLASS = 'is-sticky';
var HIDDEN_CLASS = 'is-hidden';
var PRODUCT_TEMPLATE_CLASS = 'template-product';

// Behavior
var STICKY_SHOW_SCROLL_DELTA = 24;
var STICKY_HIDE_SCROLL_DELTA = 4;

// -------------------------------------
// Helper functions
// -------------------------------------
function resetStickyState(headerSection) {
  var scrollTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  headerSection.classList.remove(STICKY_CLASS, HIDDEN_CLASS);
  lastScrollTop = scrollTop;
  directionStartScrollTop = scrollTop;
  lastScrollDirection = null;
}
function updateStickyHeader() {
  var headerSection = document.querySelector(HEADER_SELECTOR);
  if (headerSection === null) {
    stickyTicking = false;
    return;
  }
  var productSection = document.querySelector(PRODUCT_SECTION);
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
  var isDesktop = window.matchMedia(DESKTOP_MEDIA_QUERY).matches;
  var isProductTemplate = document.body.classList.contains(PRODUCT_TEMPLATE_CLASS);
  var noScrollBody = document.body.classList.contains('noscroll');
  // A desktop mega-menu dropdown is open (header-menu.js sets this on <html>).
  var desktopMenuOpen = document.documentElement.classList.contains('has-menu-open');
  var stickyTriggerOffset = headerSection.offsetHeight;
  if (productSection !== null || isProductTemplate || !isDesktop) {
    resetStickyState(headerSection, scrollTop);
    stickyTicking = false;
    return;
  }

  // While the page is scroll-locked or a desktop dropdown is open, keep the
  // header pinned in place. Otherwise the header can slide up (is-hidden) with
  // the open dropdown attached to it, causing the dropdown to be cut off /
  // pushed off the top of the viewport and to flicker as it re-triggers.
  if (noScrollBody || desktopMenuOpen) {
    headerSection.classList.remove(HIDDEN_CLASS);
    lastScrollTop = scrollTop;
    directionStartScrollTop = scrollTop;
    lastScrollDirection = null;
    stickyTicking = false;
    return;
  }
  if (scrollTop <= stickyTriggerOffset) {
    resetStickyState(headerSection, scrollTop);
    stickyTicking = false;
    return;
  }
  var isSticky = headerSection.classList.contains(STICKY_CLASS);
  var isHidden = headerSection.classList.contains(HIDDEN_CLASS);
  var isScrollingDown = scrollTop > lastScrollTop;
  var isScrollingUp = scrollTop < lastScrollTop;
  var scrollDirection = isScrollingDown ? 'down' : isScrollingUp ? 'up' : lastScrollDirection;
  if (scrollDirection !== null && scrollDirection !== lastScrollDirection) {
    directionStartScrollTop = lastScrollTop;
    lastScrollDirection = scrollDirection;
  }
  if (scrollDirection === 'up' && directionStartScrollTop - scrollTop >= STICKY_SHOW_SCROLL_DELTA) {
    headerSection.classList.add(STICKY_CLASS);
    headerSection.classList.remove(HIDDEN_CLASS);
    directionStartScrollTop = scrollTop;
  } else if (scrollDirection === 'down' && scrollTop - directionStartScrollTop >= STICKY_HIDE_SCROLL_DELTA && (isSticky || !isHidden)) {
    headerSection.classList.remove(STICKY_CLASS);
    headerSection.classList.add(HIDDEN_CLASS);
    directionStartScrollTop = scrollTop;
  }
  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  stickyTicking = false;
}

// -------------------------------------
// Hooks
// -------------------------------------
document.addEventListener('scroll', function () {
  if (!stickyTicking) {
    stickyTicking = true;
    window.requestAnimationFrame(updateStickyHeader);
  }
}, {
  passive: true
});
window.addEventListener('resize', updateStickyHeader);
updateStickyHeader();